import moment from 'moment';

export function formatDateUTCWithoutTime(parseableJSDate) {
    const parsedDate = new Date(parseableJSDate);
    const dateComponent = `${parsedDate.getFullYear()}-${parsedDate.getMonth() + 1}-${parsedDate.getDate()}`;
    return moment.utc(dateComponent, 'YYYY-MM-DD').toISOString();
}

export function formatAsLocalizedDateIgnoringTZ(parseableJSDate) {
    const parsedDate = new Date(parseableJSDate);
    const dateComponent = `${parsedDate.getUTCFullYear()}-${parsedDate.getUTCMonth() + 1}-${parsedDate.getUTCDate()}`;
    return moment(dateComponent, 'YYYY-MM-DD').toString();
}

export function formatAsLocalizedDateStringIgnoringTZ(parseableJSDate) {
    const parsedDate = new Date(parseableJSDate);
    return `${parsedDate.getUTCMonth() + 1}/${parsedDate.getUTCDate()}/${parsedDate.getUTCFullYear()}`;
}
